import Seo from "@/components/common/Seo";
import SectionHeading from "@/components/common/SectionHeading";
import ServicesSection from "@/components/home/ServicesSection";
import FinalCTA from "@/components/home/FinalCTA";
import GlowOrbs from "@/components/common/GlowOrbs";

export default function Services() {
  return (
    <div data-testid="page-services">
      <Seo title="Our Services" description="OPT, CPT, H-1B, full-time, contract placement, resume writing, LinkedIn optimization, mock interviews and career consultation." path="/services" />

      <section className="relative pt-16 pb-16 overflow-hidden">
        <GlowOrbs />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
          <SectionHeading
            eyebrow="Our Services"
            title="One partner. Every US IT staffing service you'll ever need."
            sub="From your first resume to your Green Card — SKVY Harmony supports every step of your US tech career journey."
          />
        </div>
      </section>

      <ServicesSection />
      <FinalCTA />
    </div>
  );
}
